export default __webpack_public_path__ + "assets/models/21fd92b48a676a1342904d0f4f0dd761.glb";